import type { SVGProps } from 'react';
const Email = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width={20}
        height={16}
        viewBox="0 0 20 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M19 0.5H1C0.801088 0.5 0.610322 0.579018 0.46967 0.71967C0.329018 0.860322 0.25 1.05109 0.25 1.25V14C0.25 14.3978 0.408035 14.7794 0.68934 15.0607C0.970644 15.342 1.35218 15.5 1.75 15.5H18.25C18.6478 15.5 19.0294 15.342 19.3107 15.0607C19.592 14.7794 19.75 14.3978 19.75 14V1.25C19.75 1.05109 19.671 0.860322 19.5303 0.71967C19.3897 0.579018 19.1989 0.5 19 0.5ZM7.25312 8L1.75 13.0438V2.95625L7.25312 8ZM8.35938 9.02187L9.49375 10.0531C9.63201 10.1796 9.81261 10.2498 10 10.2498C10.1874 10.2498 10.368 10.1796 10.5062 10.0531L11.6406 9.02187L17.0687 14H2.93125L8.35938 9.02187ZM12.7469 8L18.25 2.95625V13.0438L12.7469 8Z"
            fill="white"
        />
    </svg>
);
export default Email;
